import React from 'react';
import { FaHome, FaHandshake, FaHardHat, FaBuilding, FaRocket } from 'react-icons/fa';

function About() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="about">
      <div className="about-header">
        <img src="/logo/logo.png" alt="לוגו בינה" className="about-logo" />
        <h2>אודותינו</h2>
      </div>

      <div className="about-intro">

        <p className="about-welcome">ב"בינה לבניה", אנו מתמחים בבנייה פרטית, ומספקים שירותים מקיפים מהשלב ההתחלתי ועד מסירת המפתח. אנו מאמינים שבנייה היא לא רק תהליך טכני, אלא גם חווית חיים, ולכן אנו רואים את הלקוח במרכז.</p>
      </div>

      <div className="about-features">
        <div className="feature">
          <h3><FaHome style={{ marginLeft: '8px' }} /> בנייה פרטית</h3>
          <p>שירותים מקיפים מהשלב ההתחלתי ועד מסירת המפתח</p>
        </div>
        <div className="feature">
          <h3><FaBuilding style={{ marginLeft: '8px' }} /> שירותים נוספים</h3>
          <p>הקמת מסעדות, עבודות גמר ועבודות שלד</p>
        </div>
        <div className="feature">
          <h3><FaHardHat style={{ marginLeft: '8px' }} /> שיתוף פעולה</h3>
          <p>עבודה עם אדריכלים ומעצבים להפוך חלומות למציאות</p>
        </div>
        <div className="feature">
          <h3><FaHandshake style={{ marginLeft: '8px' }} /> אמינות ושקיפות</h3>
          <p>מערכת יחסים המבוססת על פתיחות מלאה ואחריות</p>
        </div>
      </div>

      <div className="about-text">
        <p>ניסיוננו הרב מאפשר לנו להבין את הצרכים המיוחדים של כל לקוח ולבנות פתרונות מותאמים אישית. אנו גאים בשיתוף הפעולה שלנו עם אדריכלים ומעצבים, אשר הופכים את החלומות שלכם למציאות.</p>

        <p>כל פרויקט מנוהל ביד מקצועית, מההתחלה ועד המסירה, כך שהאדריכלים והמעצבים יכולים להרגיש שקט נפשי ולדעת שהעבודות מתבצעות ברמה הגבוהה ביותר.</p>

        <p className="about-highlight">אם אתם מחפשים שותף לבנייה שמבין את הצרכים שלכם, אל תהססו לפנות אלינו. ב"בינה לבניה", אנחנו כאן כדי לבנות את החלום שלכם!</p>
      </div>

      <button className="cta-btn" onClick={scrollToContact}>
        בואו נבנה את החלום שלכם <FaRocket style={{ marginLeft: '8px' }} />
      </button>
    </section>
  );
}

export default About;
